import { render, staticRenderFns } from "./Coursedetails.vue?vue&type=template&id=1391ce40&scoped=true&"
import script from "./Coursedetails.vue?vue&type=script&lang=js&"
export * from "./Coursedetails.vue?vue&type=script&lang=js&"
import style0 from "./Coursedetails.vue?vue&type=style&index=0&id=1391ce40&lang=scss&scoped=true&"
import style1 from "./Coursedetails.vue?vue&type=style&index=1&id=1391ce40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1391ce40",
  null
  
)

export default component.exports